import OCWidgetPage from "./OCWidgetPage";

const TotalProtectionPage = () => (
  <OCWidgetPage
    title="Total Protection Roofing System®"
    description="Learn how the integrated system of components and layers helps your roof Seal, Defend, and Breathe."
    metaDescription="Explore the Owens Corning Total Protection Roofing System — an integrated system that helps your roof Seal, Defend, and Breathe."
  >
    <div className="total_protection_roofing_system" />
  </OCWidgetPage>
);

export default TotalProtectionPage;
